//------------------------------------------------------------------------------
// ReportPageLayoutModal
//------------------------------------------------------------------------------
import React, { useState, useEffect } from "react";
import { Button, Card, Form, InputNumber, Modal, Select } from "antd";
import { paperSizesEnum, pageMarginsEnum, fontNamesEnum, fontStylesEnum } from "../../../../utils/constants";
import {
  notificationSuccess,
  notificationError
} from '../../../../utils/notification'

const ReportPageLayoutModal = ({ 
  isReportPageLayoutModalOpen, 
  setIsReportPageLayoutModalOpen,
  reportDefRef,
  width,
}) => {
  if (!reportDefRef.current) {  //Return if a reportDefRef object does not exist
    console.log('Bad or missing reportDefRef')
    return (<></>)
  }

  const [form] = Form.useForm();
  const pageLayout = reportDefRef.current.pageLayout
  const [pageLayoutValues, setpageLayoutValues] = useState(pageLayout);
  const [pageSizeValue, setPageSizeValue] = useState(pageLayout?.pageFormat)
  const [pageMarginsValue, setPageMarginsValue] = useState(pageLayout?.pageMargins)

  useEffect(() => {
    setpageLayoutValues(pageLayout);
    setPageSizeValue(pageLayout.pageFormat)
    setPageMarginsValue(pageLayout.pageMargins)
    form.setFieldsValue(pageLayout);
  }, [pageLayout, isReportPageLayoutModalOpen]);

  const handleCancel = () => {
    setIsReportPageLayoutModalOpen(false)
  }

  const handleOk = () => {
    form.validateFields().then((values) => {
      let updatedDefRef = {...reportDefRef.current}
      updatedDefRef.pageLayout = values
      reportDefRef.current = updatedDefRef
      console.log('pageLayout.handleOk-result',reportDefRef.current.pageLayout)
      setIsReportPageLayoutModalOpen(false)
    });
  };

  const handlePaperSizeChange = value => {
    setPageSizeValue(value)
    form.setFieldValue("pageHeight", paperSizesEnum[value].pageHeight )
    form.setFieldValue("pageWidth", paperSizesEnum[value].pageWidth )
  }

  const handlePageMarginsChange = value => {
    setPageMarginsValue(value)
    form.setFieldValue("marginTop", pageMarginsEnum[value].marginTop)
    form.setFieldValue("marginBottom", pageMarginsEnum[value].marginBottom)
    form.setFieldValue( "marginLeft", pageMarginsEnum[value].marginLeft)
    form.setFieldValue("marginRight", pageMarginsEnum[value].marginRight)
  }

  return (
    <Modal
      title="Page Layout Settings"
      open={isReportPageLayoutModalOpen}
      closable={false}
      keyboard={false}
      footer={[
        <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
        <Button key="ok" type="primary" onClick={handleOk}>OK</Button>,
      ]}
      //width={width}
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 10 }}
        initialValues={pageLayoutValues}
      >
        <Card
          title='Font'
          bordered={true}
          style={{
              marginBottom: 30
          }}
        >
          <Form.Item
            className='form-item-text'
            label='Font:'
            name='fontName'

          >
            <Select
              defaultValue='Helvetica'
              //style={{ width: "175px" }}
              >
              {Object.keys(fontNamesEnum).map(font => (
                <option key={font} value={font}>
                {' '}
                {font}{' '}
                </option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            className='form-item-text'
            label='Font Style:'
            name='fontStyle'
          >
            <Select defaultValue='Normal'>
              {Object.keys(fontStylesEnum).map(fontStyle => (
                <option key={fontStyle} value={fontStyle}>
                {' '}
                {fontStyle}{' '}
                </option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label='Font Size:' name='fontSize'>
            <InputNumber
              defaultValue={16}
              min={4}
              max={72}
              step={0.5}
              precision={1}
            />
          </Form.Item>
        </Card>

        <Card
          title='Page orientation and size'
          bordered={true}
          style={{
              marginBottom: 30
          }}
        >
          <Form.Item
            className='form-item-text'
            label='Page Orientation:'
            name='pageOrientation'
          >
            <Select
              defaultValue='Portrait'
              //style={{ width: "125px" }}
              options={[
                  { value: 'Portrait', label: 'Portrait' },
                  { value: 'Landscape', label: 'Landscape' }
              ]}
            />
          </Form.Item>
          <Form.Item
            className='form-item-text'
            label='Page Size:'
            name='pageFormat' //store in doc?
          >
            <Select
              defaultValue='Letter'
              //style={{ width: "125px" }}
              onChange={(value) => handlePaperSizeChange(value)}
            >
              {Object.keys(paperSizesEnum).map(paperSize => (
                  <option key={paperSize} value={paperSize}>
                  {' '}
                  {paperSize}{' '}
                  </option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item 
            label='Page Width:'
            name='pageWidth'
          >
            <InputNumber
              // name={'pageWidth'}
              disabled={pageSizeValue !== "Custom"} 
              defaultValue={8.5} 
              precision={1} 
              min={1}
              max={30}
              step={0.5}
            />               
          </Form.Item>

          <Form.Item
            label='Page Height:' //Set when pageFormat selected
            name='pageHeight'
            //validateStatus={itemErrors.pageHeight ? 'error' : ''} //Test how we handle errors
            //help={itemErrors.pageHeight} //Test how we handle errors
          >
            <InputNumber 
              // name={'pageHeight'}
              disabled={pageSizeValue !== "Custom"} 
              defaultValue={11.0} 
              precision={1} 
              min={1}
              max={30}
              step={0.5}
            />  
          </Form.Item>
        </Card>

        <Card
          title='Page margins'
          bordered={true}
          style={{
              marginBottom: 30
            }}
        >
          <Form.Item
            className='form-item-text'
            label='Page Margins:'
            name='pageMargins' //Store in doc?  change marginRight to marginRight
          >
            <Select
              defaultValue='Normal'
              style={{ width: "100px" }}
              onChange={value => handlePageMarginsChange(value)}
            >
              {Object.keys(pageMarginsEnum).map(margin => (
                  <option key={margin} value={margin}>
                  {' '}
                  {margin}{' '}
                  </option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label='Top Margin:' //Set when pageMargins selected
            name='marginTop'
          >
            <InputNumber 
              // name={'maringTop'}
              disabled={pageMarginsValue !== "Custom"} 
              defaultValue={0.5} 
              precision={2} 
              min={0}
              max={2}
              step={.05}
            />
          </Form.Item>

          <Form.Item
            label='Bottom Margin:' //Set when pageMargins selected
            name='marginBottom'
          >
            <InputNumber 
              // name={'maringBottom'}
              disabled={pageMarginsValue !== "Custom"} 
              defaultValue={0.5} 
              precision={2} 
              min={0}
              max={2}
              step={.05}
            />            
          </Form.Item>

          <Form.Item
            label='Left Margin:' //Set when pageMargins selected
            name='marginLeft'
          >
            <InputNumber 
              // name={'maringLeft'}
              disabled={pageMarginsValue !== "Custom"} 
              defaultValue={0.5} 
              precision={2} 
              min={0}
              max={2}
              step={.05}
            />              
          </Form.Item>

          <Form.Item
            label='Right Margin:' //Set when pageMargins selected
            name='marginRight'
          >
            <InputNumber 
              // name={'maringRight'}
              disabled={pageMarginsValue !== "Custom"} 
              defaultValue={0.5} 
              precision={2} 
              min={0}
              max={2}
              step={.05}
            />              
          </Form.Item>
        </Card>
      </Form>
    </Modal>
  );
};

export default ReportPageLayoutModal;
